<template>
  <div>
    <b-form-group
        label=""
        description="The more fields filled in will provide a more comprehensive search and analysis. "
    >
      <toggles-form
          :data-array="toggles"
          @toggles-change="handleToggleChange"
      />
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TogglesForm from "@/components/forms/togglesForm";

export default {
  name: "AddEditSession_Agenda",
  components: {
    TogglesForm
  },
  props: {
    form: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  beforeMount() {
    this.setUpToggles();
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    setUpToggles() {
      this.toggles.forEach(aToggle => {
        if (this.settingsUser.hasOwnProperty(aToggle.property)) {
          aToggle.value = this.settingsUser[aToggle.property];
        }
      });
    },
    handleToggleChange(event) {
      //Maybe make top level
      let checkedId = event.target.id ? event.target.id : null;
      if (checkedId) {
        this.settingsUser[checkedId] = event.target.checked
            ? event.target.checked
            : false;
      }
    this.handleValueChange("careAreas", this.settingsUser);
    },
    handleValueChange(key, value) { //mixin
      this.$emit('value-change', {key:key, value:value});
    }
  },
  data() {
    return {
      production: true,
      settingsUser: {
        _hasAssessment:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasAssessment !== undefined
                ? this.form.careAreas._hasAssessment
                : true,
        _hasDiagnosis:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasDiagnosis !== undefined
                ? this.form.careAreas._hasDiagnosis
                : true,
        _hasGoals:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasGoals !== undefined
                ? this.form.careAreas._hasGoals
                : true,
        _hasPlanning:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasPlanning !== undefined
                ? this.form.careAreas._hasPlanning
                : true,
        _hasInterventions:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasInterventions !== undefined
                ? this.form.careAreas._hasInterventions
                : true,
        _hasRationale:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasRationale !== undefined
                ? this.form.careAreas._hasRationale
                : true,
        _hasEvaluation:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasEvaluation !== undefined
                ? this.form.careAreas._hasEvaluation
                : true,
        _hasPolicy:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasPolicy !== undefined
                ? this.form.careAreas._hasPolicy
                : true,
        _hasLegal:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasLegal !== undefined
                ? this.form.careAreas._hasLegal
                : true,
        _hasFinancial:
            this.form &&
            this.form.careAreas &&
            this.form.careAreas._hasFinancial !== undefined
                ? this.form.careAreas._hasFinancial
                : true,
      },
      toggles: [
        {
          name: "assessment",
          text: "Assessment",
          description:"Comprehensive evaluation of cognitive and functional abilities in a patient with dementia.",
          property: "_hasAssessment",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "diagnosis",
          text: "Diagnosis",
          description: "Identification and documentation of the primary health conditions affecting the patient.",
          property: "_hasDiagnosis",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "goals",
          text: "Goals",
          description: "Clear, measurable objectives and expected results for the patient's health and well-being",
          property: "_hasGoals",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "planning",
          text: "Planning",
          description: "Clear, measurable objectives and expected results for the patient's health and well-being",
          property: "_hasPlanning",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "interventions",
          text: "Interventions",
          description: "Specific actions and strategies implemented to address the diagnosed conditions and achieve the set goals.",
          property: "_hasInterventions",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "rationale",
          text: "Rationale",
          description: "Explanation of the scientific or clinical basis behind chosen interventions",
          property: "_hasRationale",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "evaluation",
          text: "Evaluation",
          description: "Ongoing assessment of the patient's response to interventions and adjustments to the care plan as needed.",
          property: "_hasEvaluation",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "policy",
          text: "Caregiver",
          description: "",
          property: "_hasPolicy",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "legal",
          text: "Legal",
          description: "",
          property: "_hasLegal",
          type: "btns",
          isAvail: true,
          value: true
        },
        {
          name: "financial",
          text: "Financial",
          description: "",
          property: "_hasFinancial",
          type: "btns",
          isAvail: true,
          value: true
        },
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.session-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#session_calender .btn-outline-info:hover,
#session_calender .btn-outline-info:active,
#session_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>

